export default {"src":"/_next/static/media/lead-project.be05e0dd.svg","height":96,"width":334};